import React, { useState, useEffect, useContext } from "react";
import { Grid, Button } from "@material-ui/core";
import _ from "lodash";
import * as moment from "moment";
import { useUtils } from "../../../utils";
import { useStyles } from "./style";
import withMiddleware from "../../../middleware";
import Table from "../../../components/table";
import { UserContext } from "../../../context";
import { getInviteList, inviteUser, resendInvite } from "./handler";
import SendInvite from "./send-invite";

function OrgInvites(props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [inviteUserLoader, setSendInviteLoader] = useState(false);
  const currentUser = useContext(UserContext);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [openSendInvite, setOpenSendInvite] = useState(false);
  const { showToast } = useUtils();

  const isAdminMode = props?.isAdminMode;
  const isGroupMode = props?.isGroupMode;

  useEffect(() => {
    getOrgInvites();
  }, []);

  const tableHeader = [
    {
      title: "First name",
      field: "first_name",
      render: (rowData) => rowData?.state?.first_name,
    },
    {
      title: "Last name",
      field: "last_name",
      render: (rowData) => rowData?.state?.last_name,
    },
    {
      title: "Email",
      field: "email",
    },
    {
      title: "Org Name",
      field: "state.group_name",
      render: (rowData) => rowData?.state?.org_name,
    },
    {
      title: "Group Name",
      field: "state.group_name",
      render: (rowData) => rowData?.state?.group_name,
    },
    {
      title: "Status",
      field: "status",
      render: (rowData) => rowData?.status?.toUpperCase(),
    },
    {
      title: "Sent at",
      field: "created_at",
      render: (rowData) => moment(rowData?.created_at).format("Y-MM-DD"),
    },
  ];

  async function getOrgInvites() {
    try {
      setLoading(true);
      setColumns(tableHeader);
      const inviteList = await getInviteList(props.service);
      setData(inviteList);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function onActionClick(e, row, key) {
    if (key == "resend-invite") {
      try {
        setSendInviteLoader(true);
        const data = await resendInvite(props.service, row?.id);
        setSendInviteLoader(false);
        showToast("success", data.message);
      } catch (error) {
        setSendInviteLoader(false);
        showToast("error", error.message);
      }
    }
  }

  async function handleAdd(user) {
    try {
      setSendInviteLoader(true);
      const data = await inviteUser(props.service, user, isGroupMode ? currentUser?.current_group_id : null);
      setSendInviteLoader(false);
      setOpenSendInvite(false);
      await getOrgInvites();
      showToast("success", data.message);
    } catch (error) {
      setSendInviteLoader(false);
      // Safely surface backend validation / API errors so the toast can always render
      // and avoid passing undefined to react-toastify.
      // Common Axios error shape: error.response.data.{message|error}
      // Fallback to generic message when nothing useful is available.
      // Also log the raw error payload for debugging in the console.
      // eslint-disable-next-line no-console
      console.error("Invite user failed:", error?.response?.data || error);
      const errorMessage =
        (error?.response && (error.response.data?.message || error.response.data?.error)) ||
        error?.message ||
        "Unable to send invite. Please check the details and try again.";
      showToast("error", errorMessage);
    }
  }

  return (
    <div className={classes.root}>
      <Grid item xs={12} className={classes.table}>
        <Grid item className={classes.usersAction}>
          <Button onClick={() => setOpenSendInvite(true)} variant="outlined" color="primary">
            Invite User
          </Button>
        </Grid>
        <Table
          onActionClick={onActionClick}
          columns={columns}
          data={data}
          loading={loading}
          // dynamicAction={true}
          options={{
            search: true,
            toolbar: true,
          }}
          actions={[{ tooltip: "Resend", icon: "email", key: "resend-invite" }]}
        />
      </Grid>
      <SendInvite
        openSendInvite={openSendInvite}
        closeHandler={setOpenSendInvite}
        addHandler={handleAdd}
        currentUser={currentUser}
        loader={inviteUserLoader}
        isAdminMode={isAdminMode}
        isGroupMode={isGroupMode}
      />
    </div>
  );
}

export default withMiddleware(OrgInvites);
